﻿import {currentCulture, DateFormat, DateOnly} from "@2d-front-monorepo/core";

export function formatDate(date: DateOnly, format: DateFormat | string = "medium"): string {
	return currentCulture().formatDate(date, format);
}
